import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate, useLocation } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";

let RentDetail = () => {
  const location = useLocation();
  let [data, setData] = useState();
  const state = location.state;

  let [indexs, setIndex] = useState();
  let [count, setCount] = useState();

  let [charge, setCharge] = useState();
  let [ charggges , setChsrggess ] = useState()

  let [sel, setSel] = useState();





  let navigate = useNavigate();

  useEffect(() => {
    Start();
    User();
  }, []);

  let Start = async () => {
    console.log(state, "statestatestate");



    setCharge(JSON.parse(state.charge));
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {
     console.log(state , 'chargestatestatestatestatestatestatestatestatestatestatestatestate')
  };

  function convertDateString(dateString) {
    const now = new Date(dateString); 

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }} > 
           <p style={{ fontWeight : '700' }}>User Detail</p>
           <div className="row" style={{ marginBottom :  50 }} >

            <div className="col-3" >
              name : {state?.user?.name}
            </div>
            <div className="col-3" >email : {state?.user?.email}</div>
            <div className="col-3" >Phone no : {state?.user?.phoneno}</div>
            <div className="col-3" ></div> 
           </div>

           <p style={{ fontSize : 20 , fontWeight :'700' }}>All Payments</p>

           {
             state?.pay?.map((re , index)=>{

              let gg = {}

              if(re?.charge){
                gg = JSON.parse(re?.charge)
              }
 

              return(
                <div onClick={()=>{  }} >
                  <div className="row" >
                  <div className="col-1">
                  <p style={{ fontWeight :'700' }}>No : {index + 1}</p>
                  </div>
                    <div className="col-3">
                      
                      <p>Amount : {re?.amount} </p>
                      <p>Con fees : {re?.co_fess}</p>
                      <p>Gst : {re?.gst}</p>
                      <p>Total : {re?.totalamount}</p>
                      
                    </div>
                   
                    <div className="col-3">
                    <p style={{ color : 'red' }}>Type : {gg?.title} </p>
                      <p>Con fees : {gg?.fee} %</p> 
                    </div>
                    <div className="col-3">

                    <p>Xopay Id : {re?.xopay_id} </p>
                      <p>Pg TransactionId : {re?.pg_transactionId}</p>
                      <p  style={{
                                color:
                                re?.payment_status_msg === "Processing" ||
                                re?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : re?.payment_status_msg === "Failed"
                                    ? "red"
                                    : "green",
                                fontWeight: "700",
                              }}> {re?.payment_status_msg}</p> 

                              <p>Date : {convertDateString(re?.createdAt)}</p>
                    </div>
                  </div>
                  <hr />
                </div>
              )

             })
           }

        </div>
      </div>
    </div>
  );
};

export default RentDetail;
